import streetlight.web.ui.viewApp



fun main() {
    println("loading streetlight")
    viewApp()
}